import React from 'react';
import Home from 'images/Home.webp';

class App extends React.Component {
  render () {
    return (
      <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' }}>
        <div style={{ fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%', color: '#186279' }}>歡迎蒞臨</div>
        <div style={{ fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%', color: '#186279' }}>離岸風力發電設置案件</div>
        <div style={{ fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%', color: '#186279' }}>工作進度資訊管考平台</div>
        {/* <div style={{ fontSize: 14, lineHeight: '20px', letterSpacing: '0.25%', color: 'rgba(0, 0, 0, 0.54)', marginTop: 34, marginBottom: 22 }}>請點選左上角menu進入選單列</div> */}
        <div style={{ fontSize: 14, lineHeight: '20px', letterSpacing: '0.25%', color: 'rgba(0, 0, 0, 0.54)', marginTop: 34, marginBottom: 22 }}>{''}</div>
        <img style={{ width: 471, height: 87, pointerEvents: 'none' }} src={Home} alt='' />
      </div>
    );
  }
}

export default App;
